let componentIndexCounter = 0;
let timer: ReturnType<typeof setTimeout> | null = null;

const hideTimeout = 80;
const hideTimer: ReturnType<typeof setTimeout>[] = [];
const hideTimerIndex: number[] = [];

export const setNumberResult = (rootEl: HTMLElement, resultNumberClass: string, count: number) => {
  const resultNumberLi = rootEl.querySelectorAll(`.${resultNumberClass}`);
  resultNumberLi.forEach((el) => {
    el.textContent = count.toString();
  });
}

export const addHighlightElem = (itemString: string, searchString: string): string => {
  const index = itemString.toLowerCase().indexOf(searchString.toLowerCase());

  if (index < 0)
    return itemString;

  return itemString.substring(0, index)
    + `<span class="highlight">${itemString.substring(index, index + searchString.length)}</span>`
    + itemString.substring(index + searchString.length);
};

export const setClassCascade = (listEl: NodeListOf<HTMLUListElement>, listItemClass: string, hide: boolean = true) => {
  hideTimer[componentIndexCounter] = setInterval(() => {
    const index = hideTimerIndex[componentIndexCounter];
    if (listEl[index]) {
      if (hide) {
        listEl[index].classList.add(`${listItemClass}--hidden`);
      } else {
        listEl[index].classList.remove(`${listItemClass}--hidden`);
      }

    }
    if (listEl[index] && index >= 0 && index <= listEl.length - 1) {
      hideTimerIndex[componentIndexCounter] = hide ? index - 1 : index + 1;
    } else {
      clearInterval(hideTimer[componentIndexCounter]);
    }
  }, hideTimeout);
};

export const setInputLoadingIndicatorVisible = (rootEl: HTMLElement, searchInputIndicatorClass: string, visible: boolean) => {
  const inputIndicator = rootEl.querySelector<HTMLDivElement>(`.${searchInputIndicatorClass}`);
  if (inputIndicator) {
    if (visible) {
      inputIndicator.classList.add(`${searchInputIndicatorClass}--visible`);
    } else {
      inputIndicator.classList.remove(`${searchInputIndicatorClass}--visible`);
    }
  }
}

export const updateInputLoadingIndicatorPosition = (rootEl: HTMLElement, searchInputClass: string, searchInputIndicatorClass: string): void => {
  const searchInput = rootEl.querySelector<HTMLInputElement>(`.${searchInputClass}`);
  if (searchInput === null) {
    return;
  }

  const text = searchInput.value.length === 0 ? searchInput.placeholder : searchInput.value;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    return;
  }
  ctx.font = window.getComputedStyle(searchInput).font;

  const inputSearchIndicator = rootEl.querySelector<HTMLDivElement>(`.${searchInputIndicatorClass}`);

  if (inputSearchIndicator) {
    inputSearchIndicator.style.left = `${ctx.measureText(text).width ?? 0}px`;
  }
};

export const smoothHideOrShowItemList = (rootEl: HTMLElement, LIST_ITEM_CLASS: string, hide: boolean = true) => {
  const listEl = rootEl.querySelectorAll<HTMLUListElement>(`.${LIST_ITEM_CLASS}--hidden`);
  if (listEl.length > 0) {
    if (hideTimer[componentIndexCounter]) {
      clearTimeout(hideTimer[componentIndexCounter]);
    }

    if (hide) {
      hideTimerIndex[componentIndexCounter] = listEl.length - 1;
    } else {
      hideTimerIndex[componentIndexCounter] = 0;
    }
    setClassCascade(listEl, LIST_ITEM_CLASS, hide);
  }
};

export const resetHideTimer = () => {
  if (hideTimer[componentIndexCounter]) {
    clearTimeout(hideTimer[componentIndexCounter]);
  }
}

const resetTimer = () => {
  if (timer) {
    clearTimeout(timer);
  }
};

export const searchDebounce = (searchTimeout: number, callback: () => void) => {
  resetTimer();
  timer = setTimeout(() => {
    if (callback) {
      callback();
      timer = null;
    }
  }, searchTimeout);
};
